import { useLocation } from "react-router"
import { useAppState } from "../../overmind"
import CourseFavoriteButton from "../CourseFavoriteButton"
import Breadcrumbs from "./Breadcrumbs"
import ToggleSwitch from "./ToggleSwitch"

const NavBarActiveCourse = () => {
    const location = useLocation()
    const activeCourse = useAppState((state) => state.activeCourse ? (state.courses.find((c) => c.ID === state.activeCourse) ?? null) : null)
    const enrollment = useAppState((state) => state.enrollmentsByCourseID[state.activeCourse?.toString() ?? ""] ?? null)
    const { isLoggedIn } = useAppState()

    if (!isLoggedIn || !activeCourse || !enrollment || location.pathname === "/") {
        return null
    }

    return (
        <div className="flex items-center gap-4">
            <ToggleSwitch />
            <Breadcrumbs />
            <CourseFavoriteButton enrollment={enrollment} />
        </div>
    )
}

export default NavBarActiveCourse
